module.exports = __webpack_public_path__ + "static/media/bowlingbrook.8e5c1265.jpg";